var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-bottom-menu"},[_c('Notifycations',{attrs:{"icon-size":24}}),_vm._v(" "),_c('Avatar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }